module.exports = __webpack_public_path__ + "img/alert-circle-outline.f87c41e0.svg";